import { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function useAutoSave(resumeId, dataLoaded, buildResumePayload) {
  const [autoSaveStatus, setAutoSaveStatus] = useState('saved');
  const isFirstRender = useRef(true);

  const autoSave = useCallback(async () => {
    if (!resumeId) return;
    setAutoSaveStatus('saving');
    try {
      const payload = buildResumePayload();
      await axios.put(`${API_URL}/api/resumes/${resumeId}`, payload, { withCredentials: true });
      setAutoSaveStatus('saved');
    } catch (_) {
      setAutoSaveStatus('error');
    }
  }, [resumeId, buildResumePayload]);

  const triggerAutoSave = useCallback(() => {
    if (!dataLoaded || !resumeId) return;
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setAutoSaveStatus('unsaved');
  }, [dataLoaded, resumeId]);

  useEffect(() => {
    if (autoSaveStatus !== 'unsaved') return;
    const timer = setTimeout(() => {
      autoSave();
    }, 3000);
    return () => clearTimeout(timer);
  }, [autoSaveStatus, autoSave]);

  return { autoSaveStatus, triggerAutoSave, autoSave };
}
